// extracted by mini-css-extract-plugin
module.exports = {"text":"Bunker_text__7OQTc","card":"Bunker_card__j4i5q","item":"Bunker_item__wmniS","itemLocked":"Bunker_itemLocked__qCXaG","tooltip":"Bunker_tooltip__a_dj4"};